// extracted by mini-css-extract-plugin
export default {"createPatientSubLabel":"CreatePatientPopup_createPatientSubLabel__oLhYW","footer":"CreatePatientPopup_footer__ZY7Ok"};